<template>
    <div v-if="!accept" class="p-5">
      Bạn chưa được phép xem trang này!
    </div>
    <div v-else>
        <b-button variant="primary" @click="gotoEdit" class="ml-2" v-if="editable">Sửa nội dung</b-button>

        
        <template v-if="currentRecord">
          <b-button variant="primary" @click="convertToProduct" class="ml-2" v-if="!isConverting && !currentRecord.product_id && editable">Copy sang ký gửi</b-button>
          <b-spinner v-if="isConverting" label="Spinning"></b-spinner>
        </template>

        <template v-if="currentRecord" >
          <b-button variant="info" class="ml-2" @click="gotoLinkedProduct" v-if="currentRecord.product_id">Xem sản phẩm ký gửi</b-button>
        </template>
        <hr/>

        <generic-detail-view
            rootPath="/v2/online_scan"
            :forms="forms"
            :columns="columns"
            :table_name="table_name"
            :service="service"
            >

        </generic-detail-view>
<!--         
        <div class="row" v-if="isLoading">
            Loading...
        </div> -->
        
    </div>

</template>

<script>
import TableMeta from '@/models/OnlineScanTableMeta'
import ProductTableMeta from '@/models/ProductTableMeta'
import GenericDetailView from '@/views/base/GenericDetailView'
import OnlineScanService from '@/services/onlineScanService'
import ProductService from '@/services/productService'
import moment from 'moment'
import Constants from '@/constants'
import axios from 'axios'

export default {
  name: 'DatabaseViewDetail',
  components: {
      'generic-detail-view': GenericDetailView
    },
  data () {
    return {
        forms: TableMeta.input_view.forms,
        columns: TableMeta.columns,
        table_name: TableMeta.table_name,
        isConverting: false,
        currentRecord: null
    }
  },
  computed: {
    email() {
      console.log('trying to get user email: ', this.$store.state.userEmail)
      if (this.$store.state.userEmail) {
        return this.$store.state.userEmail;
      }

      return ''; // empty
    },
    service () {
      return new OnlineScanService(TableMeta.table_name);
    },
    accept() {
      // if (this.$store.rentgetters.role == 'ctv') {
      //   return false;
      // }
      return true;
    },
    editable () {
      var m_editable = this.$store.getters.permissions  && this.$store.getters.permissions['scan_input'];
      m_editable = m_editable || this.$store.getters.role == "admin";

      if (m_editable) 
      {
        return true;
      }

      return false;
    },
  },
  methods: {
    gotoEdit () {
      var id = this.$route.params.id;
      this.$router.push({path: `/v2/online_scan/${id}`});
    },

    gotoLinkedProduct() {
      if(this.currentRecord && this.currentRecord.product_id) {
        let routeData = this.$router.resolve({path: `/v2/products/${this.currentRecord.product_id}`});
        window.open(routeData.href, '_blank');
      }
    },

    convertOnlineRowToProductRow(scanRow) {
      var productRow = {};

      productRow = scanRow;
      if(scanRow.rent) {
        productRow.priceForRent = scanRow.price;
        productRow.price = 0;
        productRow.status='Cho thuê';
      } else {
        productRow.price = scanRow.price;
        productRow.priceForRent = 0;
        productRow.status='Đang bán';
      }

      productRow['code'] = 'ONKG' + moment().format('DDMMYYYY-mmss');

      if(this.email) {
        productRow['created_by'] = this.email;
      }

      // remove un-compatible field
      delete productRow['id']
      delete productRow['week_start']
      delete productRow['rent']

      return productRow;
    },

    async getCurrentRowDetail() {
      var id = this.$route.params.id;
      // get current row data
      var onlineService = new OnlineScanService(TableMeta.table_name);

      this.currentRecord = await onlineService.getDetail(id);
      console.log('online scan row', this.currentRecord);
    },

    async convertToProduct () {
      this.isConverting = true;

  
      // convert to product
      /* Nhấn nút chuyển đổi thì hiện ra option chọn Trạng thái: Đang bán / Cho thuê / Bán hoặc cho thuê
      // Nếu sp nào có gắn nút Cho thuê, thì Giá > Giá cho thuê
      // Nếu sp nào ko có gắn nút Cho thuê, thì Giá > Giá kêu bán
      */
      var productRow = this.convertOnlineRowToProductRow(this.currentRecord);
      console.log('product row', productRow);

      var columns = [];
      var values = [];

      // loop through productRow keys
      for(var col_name in productRow) {
          var value = productRow[col_name];
          if(!value) {
            continue; // skip null value
          }

          columns.push(col_name);
          values.push(this.getValueFromField(value))             
      }

      var query = this.generateInsertQuery(columns, values);
      console.log(query);

      var url = Constants.HOST_URL + 'runQuery/insert';

      try {
        var response = await axios.post(url,{
            query: query
        });
        console.log(response.data);

        var productId = response.data.insertId;
        console.log('productID: ', productId);

        // save current record into online scan table
        var onlineService = new OnlineScanService(TableMeta.table_name);
        var id = this.$route.params.id;
        onlineService.updateOnlineScanColumn(id, 'product_id', productId, 'number');
        this.currentRecord.product_id = productId;
      }
      catch (e) {
        alert(e);
      }

      // save current record into online scan table
      this.isConverting = false;

      let routeData = this.$router.resolve({path: `/v2/products/${productId}`});
      window.open(routeData.href, '_blank');

      
    },

    getValueFromField (field) {
      console.log('type of ' + field + ' is ' + typeof(field));

        if(field) {
            if(field instanceof Array) {
                var s = JSON.stringify(field);
                return "'" + s + "'";
            } else if(typeof(field)==="string") {
                return "'" + field + "'";
            } else if(typeof(field)==="number") {
                return field;
            }
        }

        return null;
    },

    generateInsertQuery(columns, values) {
        var query = 'INSERT INTO ' + ProductTableMeta.table_name + ' (';
        query += columns.join(',');
        query += ') VALUES (';
        query += values.join(',');
        query += ');';

        return query;
    }
  },
  mounted () {
    this.getCurrentRowDetail();

    console.log('this.$store.getters = ', this.$store.getters);
  }
}
</script>

